(function () {
  var gate = document.getElementById("ageGate");
  if (!gate) return;

  // Don't show the gate on the "not eligible" page (avoid infinite loop)
  if (window.location.pathname === "/pages/not-eligible") {
    gate.style.display = "none";
    return;
  }

  var YES_KEY = "kk_age_verified";
  var remembered = localStorage.getItem(YES_KEY) === "true";

  if (remembered) {
    gate.style.display = "none";
    return;
  }

  var yesBtn = document.getElementById("ageYes");
  var noBtn = document.getElementById("ageNo");

  function closeGate() {
    gate.style.display = "none";
    document.documentElement.classList.remove("ageGate-open");
  }

  document.documentElement.classList.add("ageGate-open");

yesBtn && yesBtn.addEventListener("click", function () {
  localStorage.setItem(YES_KEY, "true");
  closeGate();
});

  noBtn && noBtn.addEventListener("click", function () {
    window.location.replace("/pages/not-eligible");
  });
})();
